import { FormType } from '../../../types/types';
import loginSettingsParams from '../../Login/settingsParams';
import signupSettingsParams from '../../Signup/settingsParams';
import { useSettings } from '@wix/tpa-settings/react';
import { UseLogoSettingsParams, LogoSettings } from './settings.types';

const PARAMS: Record<FormType, LogoSettings> = {
  login: loginSettingsParams,
  signup: signupSettingsParams,
};

export const useLogoSettings = ({ formType }: UseLogoSettingsParams) => {
  const settings = useSettings();

  if (!(formType in PARAMS)) {
    return {};
  }

  const settingsParams = PARAMS[formType];

  const logoUrl = settings.get(settingsParams.logoUrl);
  const logoAltText = settings.get(settingsParams.logoAltText);

  return { logoUrl, logoAltText };
};
